<div class="action-bar">
  <ng-content select="ng-container[action-bar-items]"></ng-content>
</div>
<ng-content></ng-content>
